import {
  getCandidateDetailsRoute,
  getJobDetailsRoute,
  getServicePageRoute,
  getServiceRequestPageRoute,
} from "../../../routers/routeUtils";

import { Notification } from "../types/notification";
import { ServiceTypeEnum } from "../../GoService/enum/service.enum";
import { GoHireNotificationEnum, GoServiceNotificationEnum } from "../enums/notifications";

export const getNotificationRoute = (notification: Notification) => {
  let route = null;

  const requestId =
      notification.additionalPropertiesJson?.requestId ??
      notification.additionalProperties?.requestId ??
      notification.additionalProperties.serviceContract?.serviceRequestId,
    serviceId =
      notification.additionalPropertiesJson?.serviceId ??
      notification.additionalProperties?.serviceId ??
      notification.additionalProperties.service?.id,
    serviceType =
      notification.additionalPropertiesJson?.serviceType ??
      notification.additionalProperties?.serviceType ??
      notification.additionalProperties.service?.type;

  const jobId = notification.additionalPropertiesJson?.jobId,
    candidateId = notification.additionalPropertiesJson?.candidateId;

  if (requestId) {
    let tab: "details" | "chat" | "contract" | undefined = undefined;
    switch (notification.type) {
      case GoServiceNotificationEnum.GOSERVICE_CHAT_MESSAGE_SENT:
        tab = "chat";
        break;
      case GoServiceNotificationEnum.GOSERVICE_CONTRACT_APPROVED:
      case GoServiceNotificationEnum.GOSERVICE_CONTRACT_DECLINED:
      case GoServiceNotificationEnum.GOSERVICE_CONTRACTED:
      case GoServiceNotificationEnum.GOSERVICE_CONTRACT_MILESTONE_ACHIEVED:
      case GoServiceNotificationEnum.GOSERVICE_CONTRACT_MILESTONE_COMPLETED_REMINDER:
      case GoServiceNotificationEnum.GOSERVICE_CONTRACT_MILESTONE_RELEASED:
      case GoServiceNotificationEnum.GOSERVICE_CONTRACT_PAID:
        tab = "contract";
        break;
    }
    route = getServiceRequestPageRoute(requestId, tab);
  } else if (serviceId) {
    if (serviceType === ServiceTypeEnum.Program) {
      route = getServicePageRoute(serviceId, ServiceTypeEnum.Program);
    } else {
      route = getServicePageRoute(serviceId, ServiceTypeEnum.OneTime);
    }
  } else if (jobId && candidateId) {
    if (notification.type === GoHireNotificationEnum.JOB_APPLICATION_RECEIVED) {
      route = getCandidateDetailsRoute(jobId, candidateId);
    }
  } else if (jobId) {
    if (notification.type === GoHireNotificationEnum.JOB_APPROVED) {
      route = getJobDetailsRoute(jobId);
    }
  }

  return route;
};
